import React from 'react';
import { Download, Settings2, Database, Save, Share2, Edit2, Trash2, Sparkles, Copy } from 'lucide-react';
interface TableActionsMenuProps {
  onDuplicate?: () => void;
  onRemove?: () => void;
  onClose: () => void;
  style: React.CSSProperties;
}
export function TableActionsMenu({
  onDuplicate,
  onRemove,
  onClose,
  style
}: TableActionsMenuProps) {
  return <div data-portal-menu className="jua-actions-menu fixed w-44 rounded-xl shadow-2xl shadow-black/50 py-1 border border-white/[0.08] overflow-hidden" style={style} data-id="element-1994">
      <div className="absolute inset-0 rounded-xl pointer-events-none" style={{
      background: 'linear-gradient(135deg, rgba(255,255,255,0.06) 0%, transparent 50%, rgba(255,255,255,0.02) 100%)'
    }} data-id="element-1995" />
      <button className="relative w-full px-3 py-2 text-left text-xs text-[#EC4899] hover:bg-[#EC4899]/10 flex items-center gap-2 font-medium" data-id="element-1996">
        <Sparkles size={12} data-id="element-1997" /> Edit with AI
      </button>
      <div className="h-px bg-white/[0.08] my-1" data-id="element-1998" />
      <button className="relative w-full px-3 py-2 text-left text-xs text-slate-300 hover:bg-white/[0.06] flex items-center gap-2" data-id="element-1999">
        <Download size={12} data-id="element-2000" /> Download CSV
      </button>
      <button className="relative w-full px-3 py-2 text-left text-xs text-slate-300 hover:bg-white/[0.06] flex items-center gap-2" data-id="element-2001">
        <Settings2 size={12} data-id="element-2002" /> Display Settings
      </button>
      <button className="relative w-full px-3 py-2 text-left text-xs text-slate-300 hover:bg-white/[0.06] flex items-center gap-2" data-id="element-2003">
        <Database size={12} data-id="element-2004" /> Edit Data Source
      </button>
      <button className="relative w-full px-3 py-2 text-left text-xs text-slate-300 hover:bg-white/[0.06] flex items-center gap-2" data-id="element-2005">
        <Save size={12} data-id="element-2006" /> Save Settings
      </button>
      <div className="h-px bg-white/[0.08] my-1" data-id="element-2007" />
      <button className="relative w-full px-3 py-2 text-left text-xs text-slate-300 hover:bg-white/[0.06] flex items-center gap-2" data-id="element-2008">
        <Share2 size={12} data-id="element-2009" /> Share
      </button>
      <button className="relative w-full px-3 py-2 text-left text-xs text-slate-300 hover:bg-white/[0.06] flex items-center gap-2" data-id="element-2010">
        <Edit2 size={12} data-id="element-2011" /> Edit
      </button>
      <div className="h-px bg-white/[0.08] my-1" data-id="element-2012" />
      <button className="relative w-full px-3 py-2 text-left text-xs text-slate-300 hover:bg-white/[0.06] flex items-center gap-2" onClick={() => {
      onDuplicate?.();
      onClose();
    }} data-id="element-2013">
        <Copy size={12} data-id="element-2014" /> Duplicate
      </button>
      <button className="relative w-full px-3 py-2 text-left text-xs text-red-400 hover:bg-red-500/10 flex items-center gap-2" onClick={() => {
      onRemove?.();
      onClose();
    }} data-id="element-2015">
        <Trash2 size={12} data-id="element-2016" /> Delete
      </button>
    </div>;
}